import React from "react";
import Slider from "react-slick";
import "../styles/Brands.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Brands = () => {
  const carBrands = [
    { name: "VW", logo: "/vw.jpg" },
    { name: "OPEL", logo: "/opel.jpg" },
    { name: "Nissan", logo: "/nissan.jpg" },
    { name: "Ford", logo: "/ford.jpg" },
    { name: "Peugeot", logo: "/peugeot.jpg" },
    { name: "BMW", logo: "/bmw.jpg" },
    { name: "KIA", logo: "/kia.jpg" },
    { name: "HYUNDAI", logo: "/hyundai.jpg" },
    { name: "MERCEDES", logo: "/mercedes.jpg" },
    { name: "RENAULT", logo: "/renault.jpg" },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="brands-section py-16">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">
        Our Stocked Brands
      </h2>
      <div className="container mx-auto">
        <Slider {...settings}>
          {carBrands.map((brand, index) => (
            <div key={index} className="text-center p-4">
              <img
                src={brand.logo}
                alt={brand.name}
                className="mx-auto mb-4 brand-item"
                style={{ width: "80px", height: "auto" }}
              />
              <p className="text-lg font-semibold">{brand.name}</p>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Brands;
